import React, { useState } from 'react';
import axios from '../axios/axios';  // Ensure this import is correct

export const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    subject: '',
    message: ''
  });

  const [responseMessage, setResponseMessage] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validate the form
  const validateForm = () => {
    const errors = {};
    if (!formData.firstName) errors.firstName = 'First name is required';
    if (!formData.email) errors.email = 'Email is required';
    if (!formData.subject) errors.subject = 'Subject is required';
    if (!formData.message) errors.message = 'Message is required';
    return errors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    setFormErrors(errors);

    // If there are validation errors, stop form submission
    if (Object.keys(errors).length > 0) return;

    try {
      const response = await axios.post('contact-send-mail', formData);
      setResponseMessage(response.data.message);
      setFormData({ firstName: '', email: '', subject: '', message: '' });
      setError('');
    } catch (err) {
      console.error('Error during form submission:', err);
      setError('An error occurred while submitting the form.');
      setResponseMessage('');
    }
  };

  return (
    <section className="border text-center mb-5 p-4 bg-light">
      <h3 className="mb-5">Contact Us</h3>
      <div className="row">
        {/* Map Section (50% width) */}
        <div className="col-md-6">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.444297669482!2d73.94012291488617!3d18.506959387419776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b8a06274a62d%3A0x345b16d51c28572e!2s18%C2%B030'25.1%22N%2073%C2%B056'33.7%22E!5e0!3m2!1sen!2sttu!4v1649339743500!5m2!1sen!2sttu"
            className="h-100 w-100"
            style={{ border: '0' }}
            loading="lazy"
          ></iframe>
        </div>

        {/* Contact Form Section (30% width) */}
        <div className="col-md-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="firstName" className="form-label">First Name</label>
              <input
                type="text"
                className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`}
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              {formErrors.firstName && <div className="invalid-feedback">{formErrors.firstName}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                type="email"
                className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input
                type="text"
                className={`form-control ${formErrors.subject ? 'is-invalid' : ''}`}
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
              {formErrors.subject && <div className="invalid-feedback">{formErrors.subject}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                className={`form-control ${formErrors.message ? 'is-invalid' : ''}`}
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
              {formErrors.message && <div className="invalid-feedback">{formErrors.message}</div>}
            </div>
            <button type="submit" className="btn btn-primary mb-4">Send</button>
            {responseMessage && <p className="text-success">{responseMessage}</p>}
            {error && <p className="text-danger">{error}</p>}
          </form>
        </div>

        {/* Address Section (20% width) */}
        <div className="col-md-2">
          <ul className="list-unstyled">
            <li>
              <i className="fas fa-map-marker-alt fa-2x text-primary"></i>
              <p>
                <strong>Regional Office Address</strong>
                <br />
                <small className="text-muted">
                GRAN ASIA LIFE SCIENCES LLP SHOP NO.5,4A GROUND FLOOR,CTS NO.1511-B, SAPTASHRUNGI APT.NO.5, SADASHIV PETH,Pune 411030,Maharashtra,India
                </small>
              </p>
            </li>
            <li>
              <i className="fas fa-map-marker-alt fa-2x text-primary"></i>
              <p>
                <strong>Regional Office Address</strong>
                <br />
                <small className="text-muted">
                Bldg no 106,Shop no 10, Devdoot CHS, Near Mhada Colony,G M
                Link Road, Mankhurd, Mumbai City, Maharashtra, 400088
                </small>
           
              </p>
            </li>
            <li>
              <i className="fas fa-phone fa-2x text-primary"></i>
              <p>
                <small>+91-7447454145</small>
              </p>
            </li>
            <li>
              <i className="fas fa-envelope fa-2x text-primary"></i>
              <p>
                <small>infogranasia@gmail.com</small>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
